"use client";
import React, { useState } from "react";
import Banner from "@/components/Banner";
import Breadcrumbs from "@/components/Breadcrumbs";
import Image from "next/image";
import { ChevronRight, X } from "lucide-react";
import UserFormModal from "@/components/UserFormModal";
import HighlightsAndStats from "@/components/HighlightsAndStats";

// export const metadata = {
//   title: "Fee Structure - Medhavi Skills University",
//   description: "Fee Structure page of Medhavi Skills University.",
//   keywords: [
//     "Medhavi Skills University", "Fee Structure"
//   ],
// };

const FeeStructure = () => {
  const banner_bredcrumb_name = "";
  const banner_name = "Fee Structure 2026-2027";
  const bannerUrl =
    "https://cdn.msu.edu.in/msu-reavamp/banner/_RAH6554-Fees+structure.jpg";

  const [open, setOpen] = useState(false);
  const [shouldDownload, setShouldDownload] = useState(false);

  const data = {
    announcements: [
      "to features Learn & Earn during Degree",
      "to promote NEP2020 with Industry Integration",
      "to promote Overseas Mobility",
      "to be the Awarding Body of UGC & NCVET, MSDE, Gol",
    ],
    stats: [
      { label: "Industry & Skilling Partners", value: "650+" },
      { label: "Sectors Covered", value: "30+" },
      { label: "Central Ministries & State Government Partners", value: "20+" },
      { label: "CSR Partners", value: "20+" },
      { label: "Defense Partners", value: "10+" },
    ],
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";
    link.download = "MSU-FEE-STRUCTURE-2026-27.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFormSuccess = () => {
    if (shouldDownload) {
      handleDownload();
      setShouldDownload(false);
    }
  };

  return (
    <>
      <Banner
        BannerImage={bannerUrl}
        banner_bredcrumb_name={banner_bredcrumb_name}
        banner_name={banner_name}
        banner_tag_line="An Investment in Skills and Careers"
      />
      <Breadcrumbs items={[{ label: "Fee Structure 2026-2027" }]} />

      <UserFormModal
        isOpen={open}
        onClose={() => setOpen(false)}
        onSuccess={handleFormSuccess}
        shouldDownload={shouldDownload}
      />
      <section className="w-full mx-auto block md:flex justify-center">
        <div className="max-w-[var(--max-page-width)] mx-auto px-[var(--container-padding)] top_bottom_space flex flex-col justify-between">
          <div className="w-full mx-auto">
            <div className="w-full flex flex-col items-center justify-center">
              <div className="mx-w-100 h-auto border border-gray-300">
                <Image
                  src="https://cdn.msu.edu.in/msu-reavamp/banner/MSU-FEE-STRUCTURE-2026-27-pages.webp"
                  alt="Fee Structure 2026-2027"
                  width={1000}
                  height={1000}
                  className="
                  relative w-full max-w-[500px]
                  h-[320px]
                  sm:h-[380px]
                  md:h-[480px]
                  lg:h-[520px]
                  border border-gray-300
                  overflow-hidden
                  "
                />
              </div>

              <button
                onClick={() => {
                  setShouldDownload(true);
                  setOpen(true);
                }}
                className="cursor-pointer mt-4 md:mt-8 text-[#E09512] flex items-center justify-center gap-2"
              >
                <span className="text-[#E09512] font-semibold text-lg md:text-2xl ">
                  DOWNLOAD
                </span>
                <span
                  className="cursor-pointer bg-[#00304b] border border-gray-300 rounded-full p-2 shadow hover:bg-black transition"
                  aria-label="Next"
                >
                  <ChevronRight className="w-4 md:w-6 h-4 md:h-6  text-4xl text-white" />
                </span>
              </button>
            </div>

            <HighlightsAndStats data={data} />
          </div>
        </div>
      </section>
    </>
  );
};

export default FeeStructure;
